import type { FixedTextProperties, FormElement } from '../../model/form.types';
import type { StaticDefinition } from '../../model/types';
import { textStyle } from './shared';

type FixedTextElement = FormElement & { properties: FixedTextProperties };

export const fixedTextDefinition: StaticDefinition<FixedTextElement> = {
  kind: 'static',
  type: 'FIXED_TEXT',
  compile: (element) => ({
    kind: 'static',
    id: element.id,
    type: 'FIXED_TEXT',
    text: element.properties.content ?? '',
    style: textStyle(element),
    visible: true,
    element,
  }),
};
